<template>
  <SettingsPageLayout v-if="loaded">
    <Header :task-name="taskName" @add-checklist="showNewModal = true" />
    <List
      :task-name="taskName"
      :checklists="offboardingChecklists"
      :setup-task-link="buildSetupTaskLink"
      @refresh="fetchOffboardingChecklists"
    />

    <UpsertModal
      form-kind="new"
      :task-name="taskName"
      :show-modal="showNewModal"
      @name-input="newChecklist.name = $event"
      @action="createChecklist"
      @close-modal="showNewModal = false"
    />
  </SettingsPageLayout>
</template>

<script>
import { Api } from '../../../api';
import SettingsPageLayout from '../../layouts/SettingsPageLayout/index.vue';
import Header from './ChecklistSettings/Header.vue';
import List from './ChecklistSettings/List.vue';
import UpsertModal from './ChecklistSettings/UpsertModal.vue';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

const DEFAULT_NEW_CHECKLIST = {
  name: '',
  checklist_type: 'offboarding',
  primary_user_role: 'agent',
};

export default {
  components: {
    SettingsPageLayout,
    Header,
    List,
    UpsertModal,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      loaded: false,
      offboardingChecklists: [],
      showNewModal: false,
      newChecklist: {
        ...DEFAULT_NEW_CHECKLIST,
      },
      taskName: 'Offboarding',
    };
  },
  async mounted() {
    await this.fetchOffboardingChecklists();
    this.loadingSpinnerStore.hideLocalLoadingSpinner();
  },
  methods: {
    async fetchOffboardingChecklists() {
      const { records } = await Api.TaskChecklists.listTaskChecklists({ type: 'offboarding' });

      this.offboardingChecklists = records;
      this.loaded = true;
    },
    async createChecklist() {
      try {
        await Api.TaskChecklists.createTaskChecklist(this.newChecklist);
        this.showNewModal = false;
        this.newChecklist = { ...DEFAULT_NEW_CHECKLIST };
        await this.fetchOffboardingChecklists();
      } catch (error) {
        console.error('Error creating checklist:', error);
      } finally {
        this.loadingSpinnerStore.hideLocalLoadingSpinner();
      }
    },
    buildSetupTaskLink(checklistId) {
      return `/settings/company/offboarding_checklists/${checklistId}/edit`;
    },
  },
};
</script>
